import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';

interface ITextBlockAuthProps {
    hasEquipment: boolean,
}
export const TextBlockAuth = ({ hasEquipment }: ITextBlockAuthProps): JSX.Element => {
    return (
        <TextWrapper>
            <H3>Подтвердите ваш номер телефона</H3>
            {hasEquipment && (
                <Paragraph4>Нам это нужно для создания вашей заявки на&nbsp;доставку оборудования.
                    Важное: заявку можно оставить только если вам уже 18&nbsp;лет. Дальше останется только выбрать дату и&nbsp;время визита инженера.
                </Paragraph4>
            )}
        </TextWrapper>
    );
};
